import { useEffect, useState } from "react";
import { api } from "./api";
import { Auth } from "./Auth";
import { Board } from "./Board";
import type { User } from "./types";

export function App() {
  const [user, setUser] = useState<User | null>(null);
  const [needsSetup, setNeedsSetup] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.me()
      .then((r) => { setUser(r.user); setNeedsSetup(!!r.needs2faSetup); })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="center-screen"><div className="spin" /></div>;

  // Mandatory-2FA session: not active yet, must enroll before any board access.
  if (needsSetup && user)
    return <Auth resumeSetup onAuthed={(u) => { setUser(u); setNeedsSetup(false); }} />;

  if (!user) return <Auth onAuthed={(u) => { setUser(u); setNeedsSetup(false); }} />;

  return <Board user={user} onLogout={() => { setUser(null); setNeedsSetup(false); }} onUserChange={setUser} />;
}
